import { CoreIcon } from '../core-icon';
import chevronLeftCircleSVG from '../../assets/icons/chevron-left-circle.svg';
import type { IconProps } from '../core-icon';

export const ChevronLeftCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronLeftCircleSVG} {...props} />;
};
